import React from "react";

import { portexColor, TablePagination } from "@portex-pro/ui-components";

interface CursorPaginationTableControlViewProps {
  total: number;
  page: number;
  next: () => void;
  prev: () => void;
  setTake: (take: number) => void;
  take: number;
  /** When true, `total` is a capped floor: the label shows `total+` and paging past it stays enabled. */
  paginationLimited?: boolean;
  style?: React.CSSProperties;
}

const CursorPaginationTableControlsView: React.VFC<CursorPaginationTableControlViewProps> = (props) => {
  const { page, next, prev, setTake, take, total, paginationLimited, style } = props;

  const onChangePage = (_event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, nextPage: number) => {
    nextPage > page ? next() : prev();
  };

  const onChangeRowsPerPage: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) =>
    setTake(Number(e.target.value));

  return (
    <TablePagination
      component="div"
      // A capped total is only a lower bound, so pass -1 (MUI's "unknown count") to keep the next
      // button enabled — the page query itself is not capped — and render `total+` in the label.
      count={paginationLimited ? -1 : total}
      labelDisplayedRows={paginationLimited ? ({ from, to }) => `${from}-${to} of ${total}+` : undefined}
      page={page}
      onChangePage={onChangePage}
      rowsPerPage={take}
      rowsPerPageOptions={[10, 25, 50, 100]}
      onChangeRowsPerPage={onChangeRowsPerPage}
      width="100%"
      style={{ backgroundColor: "#fff", borderTop: `1px solid ${portexColor.grey100}`, flexShrink: 0, ...style }}
    />
  );
};

export default CursorPaginationTableControlsView;
